
export interface MLevelsBaseItemInterface {
    name: string,
    sort?: number,
    level?: number,
    parent?: string,
    items?: MLevelsBaseItemInterface[]
}

export function MLevelItemsParser<T extends MLevelsBaseItemInterface>(defined_Collection?: T[][],
    extraCollection?: T[][]): T[] {
    let sort = 1000;
    // if (defined_Collection === undefined) {
    //     defined_Collection = MENUS_DEFINES;
    // }
    let rawCollection: T[] = defined_Collection[0];
    for (let i = 1; i < defined_Collection.length; i++) {
        rawCollection = rawCollection.concat(defined_Collection[i]);
    }

    if (extraCollection) {
        for (let i = 0; i < extraCollection.length; i++) {
            rawCollection = rawCollection.concat(extraCollection[i]);
        }
    }

    if (rawCollection === undefined) {
        return [];
    }

    const tmpCollection = {};
    const sortedMap = {}
    const nameCollection = {}
    for (const item of rawCollection) {
        nameCollection[item.name] = item;
    }
    for (const item of rawCollection) {
        item.level = calcItemLevel(nameCollection, item, 0);
        item.sort = item.sort ? item.sort : (sort++) * 100 + item.level * 1000;
        if (tmpCollection.hasOwnProperty(item.sort)) { //has same sort exsits
            item.sort = item.sort + 100;
        }

        tmpCollection[item.sort] = item;
        sortedMap[item.name] = item.sort;
    }

    for (let key in tmpCollection) {
        if (tmpCollection.hasOwnProperty(key)) {
            const item = tmpCollection[key];
            if (item !== undefined && item.level > 0) {
                key = sortedMap[item.parent];
                const parent = tmpCollection[key];
                if (parent !== undefined) {
                    if (parent.items === undefined) {
                        parent.items = {};
                    }
                    item.level = parent.level + 1;
                    parent.items[item.sort] = item;
                }
            }
        }
    }

    return sortCollection<T>(tmpCollection, 0);
}

function calcItemLevel(collection: any, item, level) {
    if (item.parent !== undefined) {
        const parent = collection[item.parent];
        if (parent.parent !== undefined) {
            const grandparent = collection[parent.name];
            return calcItemLevel(collection, grandparent, level + 1);
        } else {
            return level + 1;
        }
    }
    return level;
}

function sortCollection<T extends MLevelsBaseItemInterface>(collection: any, level: number): T[] {
    const items: T[] = []
    for (const key in collection) {
        if (collection.hasOwnProperty(key)) {
            const item = collection[key];
            if (item.level === undefined) {
                items.push(item);
            } else {
                if (item.level === level) {
                    if (item.items !== undefined) {
                        item.items = sortCollection(item.items, 1 + level);
                    }
                    items.push(item);
                }
            }
        }
    }
    return items;
}
